import {AfterViewInit, ChangeDetectorRef, Component, Input, OnDestroy, OnInit} from '@angular/core';
import {RealmService} from '../Services/Realm/realm.service';
import {ApiService} from '../Services/Api/api.service';
import {environment} from '../../environments/environment';
import {Location} from '@angular/common';

@Component({
  selector: 'app-provider-location',
  templateUrl: './provider-location.component.html',
  styleUrls: ['./provider-location.component.css', '../../assets/layout/style/layout.css'],
})
export class ProviderLocationComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() infoProviders: any = [];
  // @Input() typeSelectedProvider = '';
  iprov = [];
  contactProvider = [];
  scheduleProvider = [];
  hidePreviewSelectedLocation: any;
  nextSelectedLocation: any;
  selectedProvider: any;
  showDetailsSchedule = false;
  showDetailsContact = false;
  quequeVariable: string;
  quequePosition: number;
  quequeTime: string;
  cant = 1;
  isOnline: string;
  env = environment;
  displayWaitDialog: boolean;
  showDetailLocation: boolean;
  isWaiting = false;
  displayDialogUbication: boolean;
  copaymentInfo = [];
  copayment = false;
  constructor(private realm: RealmService, private apiService: ApiService, private location: Location, private cdRef: ChangeDetectorRef) {
  }

  ngOnInit(): void {
    this.realm.updateScreenProviders(2);
    console.log('ngOnInit');
    this.iprov = [];

    console.log(this.infoProviders.length);
    this.realm.locationProvider$.subscribe( (data: any) => {
      this.iprov = data;
    });
  }
  ngOnDestroy(): void {
    //this.cdRef.detach();
    console.log('ondestroy');
  }

  ngAfterViewInit(): void {
    console.log('ngAfterViewInit');
    this.cdRef.detectChanges();
  }
  showContact(event: Event, info: any, option: boolean, element) {
    this.contactProvider = [];
    this.cant = 1;
    this.showDetailsContact = false;
    this.contactProvider = [];
    this.hidePreviewSelectedLocation = element;
    this.realm.getContactProvider(info.idLocation);
    this.realm.contactListQuery$.subscribe( (data: any) => {
      this.contactProvider = [];
      this.contactProvider = data;
    });
    this.showDetailsContact = true;
    this.nextSelectedLocation = element;
    /*if (this.showDetailsContact) {
      this.showDetailsContact = false;
      this.contactProvider = [];
      this.hidePreviewSelectedLocation = element;
    } else {
      this.realm.getContactProvider(info.idLocation);
      this.realm.contactListQuery$.subscribe( (data: any) => {
        this.contactProvider = [];
        this.contactProvider = data;
      });
      this.showDetailsContact = true;
      this.nextSelectedLocation = element;
    }*/
   // op.toggle(event);
    // console.log(this.selectedProvider);
    event.preventDefault();
  }
  showSchedule(event: Event, info: any, option: boolean, element) {
    this.showDetailsSchedule = false;
    this.scheduleProvider = [];
    this.hidePreviewSelectedLocation = element;
    this.realm.getScheduleProvider(info.idLocation);
    this.realm.scheduleListQuery$.subscribe( (data: any) => {
      this.scheduleProvider = [];
      this.scheduleProvider = data;
    });
    this.showDetailsSchedule = true;
    this.nextSelectedLocation = element;
    /*if (this.showDetailsSchedule) {
      this.showDetailsSchedule = false;
      this.contactProvider = [];
      this.hidePreviewSelectedLocation = element;
    } else {
      this.realm.getScheduleProvider(info.idLocation);
      this.realm.scheduleListQuery$.subscribe( (data: any) => {
        this.scheduleProvider = [];
        this.scheduleProvider = data;
      });
      this.showDetailsSchedule = true;
      this.nextSelectedLocation = element;
    }*/
    event.preventDefault();
  }
  /*cpayment(copa: boolean) {
    this.env.isContentLoading = true;
    this.copaymentInfo = [];
    if (copa) {
      this.realm.getCopaymentbyProvider(this.typeSelectedProvider);
      this.apiService.responseGet$.subscribe( data => {
        const qw: any = data;
        console.log(qw);
        this.env.isContentLoading = false;
        if (qw.code === 701) {
          this.copaymentInfo = qw.resultInsuredPartipation.success[0];
          console.log(this.copaymentInfo);
          this.copayment = copa;
          this.displayWaitDialog = false;
          this.displayDialogUbication = false;
        }
      });
    } else {
      this.copayment = copa;
      this.displayDialogUbication = true;
    }
  }*/
}
